import _ from 'lodash';
import { v4 as uuid } from 'uuid';
import { SetCurrentNode, SetPreviewRunning } from '../constants/mutations';
import {
  GetStack,
  GetSelectedConversationNodes,
  GetNodeById,
  GetCurrentAmp,
  GetCurrentNodeId,
  GetCurrentConversationId,
} from '../constants/getters';
import { StartPreview, SetupPreview, StopPreview } from '../constants/actions';
import { buildStack } from '../utils/preview-utils';

const defaultState = () => {
  return {
    currentNodeId: '',
    previewRunning: false,
  };
};

export const state = defaultState;

export const mutations = {
  [SetCurrentNode]: (state, id) => {
    state.currentNodeId = id;
  },

  [SetPreviewRunning]: (state, value) => {
    state.previewRunning = value;
  },
};

export const getters = {
  [GetStack]: (state, _getters, rootState, rootGetters) => {
    if (state.currentNodeId) {
      const nodes = rootGetters[`builderStore/${GetSelectedConversationNodes}`];
      const node = rootGetters[`builderStore/${GetNodeById}`]({ id: state.currentNodeId });
      const stack = buildStack(node, nodes);

      return stack;
    }

    return [];
  },

  [GetCurrentAmp]: (_state, _getters, _rootstate, rootGetters) => {
    return _.cloneDeep(rootGetters[`ampStore/${GetCurrentAmp}`]);
  },

  [GetCurrentNodeId]: (state) => state.currentNodeId,
};

export const actions = {
  [SetupPreview]({ getters }, { nodeId, conversationId }) {
    const amp = getters[GetCurrentAmp];

    if (!localStorage.getItem('clientId')) {
      localStorage.setItem('clientId', uuid());
    }

    this.$chatbotService.clearState();
    this.$chatbotService.setupPreviewAmp(amp, conversationId, nodeId);
  },

  [StartPreview]({ dispatch, commit, state, rootGetters }) {
    const conversationId = rootGetters[`builderStore/${GetCurrentConversationId}`];
    const nodeId = state.currentNodeId;

    commit(SetCurrentNode, '');
    dispatch(SetupPreview, { nodeId, conversationId });
  },

  [StopPreview]({ commit }) {
    commit(SetPreviewRunning, false);
    this.$chatbotService.clearState();
  },
};
